import "styles/Layout.css";

import Column from "components/Column";
import Header from "../../components/Header";
import React from "react";
import Row from "components/Row";
import Sidebar from "../../components/Sidebar";
import TopBar from "components/TopBar";
import colors from "styles/colors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const Desktop = ({ children, title, extraPage, subTitle }) => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const history = useHistory();
  const listNoDatePickerOnTop = ["/dashboard", "/adpro-suggestions", "/payment"];
  const IsNoDatePickerOnTop = listNoDatePickerOnTop.includes(history.location.pathname);

  return (
    <StyledContainer>
      <Header />
      <Row className="wrapper">
        {!extraPage && (
          <Column width="300px" wrap>
            <Sidebar />
          </Column>
        )}
        <Column>
          {!extraPage && (
            <StyledTopBar IsNoDatePickerOnTop={IsNoDatePickerOnTop}>
              <TopBar title={title} subTitle={subTitle}></TopBar>
            </StyledTopBar>
          )}
          {children}
        </Column>
      </Row>
    </StyledContainer>
  );
};

export default Desktop;

const StyledContainer = styled.div`
  background-color: ${colors.background};
  height: 100vh;
  overflow: auto;

  > .wrapper {
    padding: 83px 0 24px;
  }
`;

const StyledTopBar = styled.div.attrs((props) => ({
  postion: props.IsNoDatePickerOnTop ? "relative" : "fixed",
  padding: props.IsNoDatePickerOnTop ? "0 0 16px" : "",
  display: props.IsNoDatePickerOnTop ? "block" : "none",
}))`
  position: ${(props) => props.postion};
  padding: ${(props) => props.padding};
  display: ${(props) => props.display};
`;
